import { Model } from '@chaysehartsuff/active-html';

export default class BlogCategory extends Model {

    id;
    name;
    order;
    meta_data;
    created_at;
    updated_at;
}